import { render } from "./TagRealmMenuOptions.vue?vue&type=template&id=2df04ad4&scoped=true"
import script from "./TagRealmMenuOptions.vue?vue&type=script&lang=js"
export * from "./TagRealmMenuOptions.vue?vue&type=script&lang=js"

import "./TagRealmMenuOptions.vue?vue&type=style&index=0&id=2df04ad4&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2df04ad4"]])

export default __exports__